import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e1979d18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "document bg-white relative overflow-y-scroll overflow-x-hidden" }
const _hoisted_2 = {
  key: 0,
  class: "body"
}
const _hoisted_3 = { class: "title-section-spacing sticky top-0 bg-white z-20" }
const _hoisted_4 = { class: "header w-full fixed relative inline-flex" }
const _hoisted_5 = {
  key: 0,
  class: "badge text-left bg-secondary-600 text-white self-center rounded-full font-bold"
}
const _hoisted_6 = {
  key: 1,
  class: "badge text-left bg-primary-100 text-black self-center rounded-full font-bold"
}
const _hoisted_7 = { class: "ml-auto button-row pt-6 pb-8" }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "my-auto mr-1 ml-2" }, "Chat", -1))
const _hoisted_10 = { class: "title-row pt-6 pb-6" }
const _hoisted_11 = { class: "font-bold block text-left pb-4" }
const _hoisted_12 = { class: "block date" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { class: "street" }
const _hoisted_17 = {
  key: 0,
  class: "font-bold grey-text text-left subtitle"
}
const _hoisted_18 = { class: "details mt-6 flex" }
const _hoisted_19 = {
  key: 0,
  class: "customer flex"
}
const _hoisted_20 = { class: "mr-6" }
const _hoisted_21 = {
  key: 1,
  class: "customer flex"
}
const _hoisted_22 = { class: "mr-6" }
const _hoisted_23 = {
  key: 2,
  class: "cruise-link flex pointer"
}
const _hoisted_24 = { class: "mr-6" }
const _hoisted_25 = ["href"]
const _hoisted_26 = { class: "working-sites-buttons grid grid-cols-3 gap-4 pt-4" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "working-site-button-regular font-bold self-center" }, "Crea QR Code", -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_SecondaryButton = _resolveComponent("SecondaryButton")!
  const _component_ClientIconSmall = _resolveComponent("ClientIconSmall")!
  const _component_DocumentIconSmall = _resolveComponent("DocumentIconSmall")!
  const _component_WorldIcon = _resolveComponent("WorldIcon")!
  const _component_WorkingSiteAssignedUsersSection = _resolveComponent("WorkingSiteAssignedUsersSection")!
  const _component_WorkingSiteClockingInsSection = _resolveComponent("WorkingSiteClockingInsSection")!
  const _component_UserWorkReportsSection = _resolveComponent("UserWorkReportsSection")!
  const _component_UserExpensesSection = _resolveComponent("UserExpensesSection")!
  const _component_ToggleEntityArchive = _resolveComponent("ToggleEntityArchive")!
  const _component_AddEditWorkingSiteModalDialog = _resolveComponent("AddEditWorkingSiteModalDialog")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.workingSite)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_ctx.workingSite.isSpecialWorkingSite)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_5, "Cantiere Speciale"))
                  : (_openBlock(), _createElementBlock("h2", _hoisted_6, "Cantiere Tradizionale")),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_SecondaryButton, {
                    class: "text-white bg-primary-900 block float-right",
                    onClick: _ctx.onChatClick
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_font_awesome_icon, {
                          class: "my-auto icon h-6",
                          icon: ['fas', 'fa-comment-dots']
                        }),
                        _hoisted_9
                      ])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                (_ctx.workingSite.isArchived)
                  ? (_openBlock(), _createBlock(_component_SecondaryButton, {
                      key: 0,
                      class: "archive-document text-white bg-primary-900 block float-right",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShowingToggleEntityArchive = true))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Riattiva cantiere")
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_SecondaryButton, {
                      key: 1,
                      class: "archive-document text-white bg-primary-900 block float-right",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowingToggleEntityArchive = true))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Archivia cantiere")
                      ]),
                      _: 1
                    })),
                _createVNode(_component_SecondaryButton, {
                  class: "edit-document text-primary block float-right mr-3",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showEditDocumentDialog()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Modifica cantiere")
                  ]),
                  _: 1
                }),
                _createElementVNode("h1", _hoisted_11, _toDisplayString(_ctx.workingSite.name), 1),
                _createElementVNode("div", _hoisted_12, [
                  (_ctx.workingSite.startTs)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.moment.unix(_ctx.workingSite.startTs).format('DD/MM/YY')), 1))
                    : _createCommentVNode("", true),
                  (_ctx.workingSite.startTs && _ctx.workingSite.endTs)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, " - "))
                    : _createCommentVNode("", true),
                  (_ctx.workingSite.endTs)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.moment.unix(_ctx.workingSite.endTs).format('DD/MM/YY')), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              (_ctx.workingSite.address)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_17, _toDisplayString(_ctx.workingSite.address.address), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_18, [
              (_ctx.workingSite.customer)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_component_ClientIconSmall, { class: "mr-2 small-path-blue self-center" }),
                    _createElementVNode("h2", _hoisted_20, _toDisplayString(_ctx.workingSite.customer), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.workingSite.orderNumber)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createVNode(_component_DocumentIconSmall, { class: "mr-2 small-path-blue self-center" }),
                    _createElementVNode("h2", _hoisted_22, "N° " + _toDisplayString(_ctx.workingSite.orderNumber), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.workingSite.link)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createVNode(_component_WorldIcon, { class: "mr-2 small-path-blue self-center" }),
                    _createElementVNode("h2", _hoisted_24, [
                      _createElementVNode("a", {
                        href: _ctx.workingSite.link,
                        target: "_blank"
                      }, "Vedi su Cruise Mapper", 8, _hoisted_25)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onGenerateQrCode())),
                class: _normalizeClass({ disabled: _ctx.workingSite.isArchived })
              }, _hoisted_28, 2),
              _createElementVNode("h2", {
                class: _normalizeClass(["working-site-button-regular font-bold self-center button", { disabled: _ctx.workingSite.isArchived }]),
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onManagePPE && _ctx.onManagePPE(...args)))
              }, "Gestisci materiale richiesto", 2),
              _createElementVNode("h2", {
                class: "working-site-button-regular font-bold self-center button",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onDocuments && _ctx.onDocuments(...args)))
              }, [
                _createTextVNode("Gestisci documenti"),
                (_ctx.documentCounter != undefined)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, " (" + _toDisplayString(_ctx.documentCounter) + ")", 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("h2", {
                class: "working-site-button-regular font-bold self-center button second-row",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onManageTime && _ctx.onManageTime(...args)))
              }, "Gestisci ore viaggio")
            ]),
            _createVNode(_component_WorkingSiteAssignedUsersSection, {
              "working-site-id": _ctx.workingSite.id,
              "working-site-name": _ctx.workingSite.name
            }, null, 8, ["working-site-id", "working-site-name"]),
            _createVNode(_component_WorkingSiteClockingInsSection, {
              id: _ctx.workingSite.id,
              scope: _ctx.ClockingInScope.workingSite,
              "working-site": _ctx.workingSite
            }, null, 8, ["id", "scope", "working-site"]),
            _createVNode(_component_UserWorkReportsSection, {
              "working-site": _ctx.workingSite,
              scope: _ctx.WorkReportScope.workingSite
            }, null, 8, ["working-site", "scope"]),
            _createVNode(_component_UserExpensesSection, {
              "working-site": _ctx.workingSite,
              scope: _ctx.UserExpenseScope.workingSite
            }, null, 8, ["working-site", "scope"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isShowingToggleEntityArchive)
      ? (_openBlock(), _createBlock(_component_ToggleEntityArchive, {
          key: 0,
          onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isShowingToggleEntityArchive = false)),
          id: _ctx.workingSite.id,
          name: _ctx.workingSite.name,
          "is-currently-archived": _ctx.workingSite.isArchived,
          scope: _ctx.EntityArchiveScope.workingSite
        }, null, 8, ["id", "name", "is-currently-archived", "scope"]))
      : _createCommentVNode("", true),
    (_ctx.editDocument)
      ? (_openBlock(), _createBlock(_component_AddEditWorkingSiteModalDialog, {
          key: 1,
          onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.hideEditDocumentDialog())),
          modelValue: _ctx.workingSite,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.workingSite) = $event))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 2,
          message: "Creazione..."
        }))
      : _createCommentVNode("", true)
  ], 64))
}